import * as React from 'react';
import { useSelector } from 'react-redux';
import dayGridPlugin from '@fullcalendar/daygrid';
import type { DayCellContentArg } from '@fullcalendar/core';
import FullCalendar from '@fullcalendar/react';
import enLocale from '@fullcalendar/core/locales/en-gb';
import nlLocale from '@fullcalendar/core/locales/nl';
import { ImmutableRootState } from '@uncinc/react-drupal-core/types';
import { DEFAULT_LANGUAGE } from '../../config/constants';

import Item from './Item';
import type { CalendarItem } from '../../types';

import './style.scss';

interface CalendarProps {
  items: CalendarItem[];
  startDate?: Date;
  endDate?: Date;
}

const Calendar: React.FC<CalendarProps> = (props) => {
  const {
    items,
    startDate,
    endDate,
  } = props;

  const calendarRef = React.useRef<FullCalendar>(null);
  const currentLanguage = useSelector<ImmutableRootState<string>, string>(
    (state) => state.getIn(['ui', 'language'], DEFAULT_LANGUAGE),
  );

  const renderDayCellContent = (arg: DayCellContentArg) => (
    <>
      <div>{arg.dayNumberText}</div>
      {arg.isToday && <div className="fc-daygrid-day-top__circleBlue" />}
    </>
  );

  return (
    <FullCalendar
      ref={calendarRef}
      plugins={[dayGridPlugin]}
      initialView="dayGridMonth"
      locales={[nlLocale, enLocale]}
      locale={currentLanguage}
      events={items}
      showNonCurrentDates={false}
      fixedWeekCount={false}
      validRange={{
        start: startDate,
        end: endDate,
      }}
      headerToolbar={{
        left: 'prev',
        center: 'title',
        right: 'next',
      }}
      dayCellContent={renderDayCellContent}
      eventContent={Item}
      eventBackgroundColor="transparent"
      eventBorderColor="transparent"
      height="auto" // No scrollbar for long months.
      eventInteractive={false} // FullCalendar's event wrappers should not be focusable/tabbable
      firstDay={1} // Start with monday.
    />
  );
};

export default Calendar;
